<template>
<div>
  <div class="top" :class="{'comment-inputfield': (column === 'extra_charges')}">
    <div class="input" @click="valueClicked">
      <input
        type="number"
        class="w70"
        :readonly="validateReadOnlyOnOldPayment(isReadOnly)"
        @input="changeCheck($event)"
          v-model="value"
        ref="numberinput"
        min='0'
        @focus="magic_flag = true"
        @blur="hideMagicFlag"
        :class="whichClass()"
      >
    </div>

  </div>

  <div class="focus-contain" v-bind:class="{ active: magic_flag}">
      <div class="focus-contain-div">
        <div class="focus-contain-close" v-if="column === 'extra_charges'">
        <svgicon name="cancelblack" width="10" height="10" @click='magic_flag = false' :original="true" />
      </div>
        <div class="focus-contain-div-list" v-if="subStatus">
          <div v-if="checkDataType.value">
          <div>{{checkDataType.label}} </div>
          <span class="focus-contain-div-text">
            {{checkDataType.value}}
            </span>

          </div>
           </div>

        <div class="focus-contain-div-list" v-for="(option, index) in options" :key="index">
          <div :class="option.fontweight">{{option.value}}</div>
          <span class="focus-contain-div-text">{{option.label}}</span>
        </div>
        <div class="text-areablock" v-if="column === 'extra_charges'">
        <textarea rows="3" v-model="misc_comments" cols="30">Comments</textarea>
        <div class="focus-contain-btn">
        <button class="btn btn-primary" v-if="misc_comments && misc_comments.length > 2" @click='addComments()'>Submit</button>
      </div>
      </div>
      </div>
    </div>
    </div>
</template>
<script>
import debounce from 'debounce';

export default {
  props: {
    label: String,
    column: String,
    subStatus: { type: Boolean, default: false },
    action: String,
    payment: Object,
    consigneeIndex: {
      type: Number,
      default: 0,
    },
    currentClientConfig: { type: Object, default: {} },
    invoiceStatus: Number,
    compareBy: Boolean,
    isReadOnly: Boolean,
    columnReadOnly: Boolean,
  },
  data() {
    return {
      magic_flag: false,
      misc_comments: null,
      aggrigate: ['contract_charge',
        'unloading_charge',
        'loading_charge',
        'lr_charge',
        'loading_detention_charge',
        'unloading_detention_charge',
        'extra_charges',
        'oda_charges',
        'additional_point_charges'],
      daysCheck: ['transit_charge', 'arrival_charge', 'loading_detention_charge', 'unloading_detention_charge'],
      quantityCheck: ['shortage_charge', 'damage_charge', 'leakage_charge', 'carton_damage_charge'],
    };
  },
  methods: {
    addComments() {
      this.$emit('addConversation', {comment: this.misc_comments, orderId: this.payment.order_id});
      this.magic_flag = false;
      this.misc_comments = null;
    },
     valueClicked() {
      if (!this.validateReadOnlyOnOldPayment(this.isReadOnly)) {
        this.magic_flag = true;
      }
    },
    amount(section) {
      let total = this.payment[this.column] ? this.payment[this.column][section] : 0;
      if (total > 0) {
        total = Number(total.toFixed(2));
      } else if (this.$store.showInvoice || this.validateReadOnlyOnOldPayment(this.columnReadOnly)) {
        total = 0;
      } else {
        total = '';
      }
      return total;
    },
    whichClass() {
      let getClass = this.amount('system') === this.amount('transporter')
        ? { 'sec-text': true }
        : {
          'primary-text': this.amount('transporter') > this.amount('system'),
          'error-text': !this.$hasFeature('transporter_payment_discount') && this.amount('transporter') < this.amount('system'),
        };
      if (this.validateReadOnlyOnOldPayment(this.columnReadOnly)) {
        getClass = Object.assign(getClass, { grey_out: true });
      }

      return getClass;
    },
    hideMagicFlag: debounce(function debounceSearch() {
      this.magic_flag = (this.column === 'extra_charges') ? true : false;
    }, 550),

    changeCheck: debounce(function debounceSearch(event) {
      this.$emit('change');
    }, 600),
    setObjDetail(section, column, val) {
      const indentIndex = this.$store.payments.selected.findIndex(indent => indent.order.order_number === this.payment.order_number);
      if (indentIndex !== -1) {
        const consignments = this.$store.payments.selected[indentIndex].charges;
        const consIndex = consignments.findIndex(consignee => consignee.consignee_id === this.payment.consignee_id);
        if (consIndex !== -1) {
          this.$store.payments.selected[indentIndex].charges[consIndex][this.column][section] = Number(val);
          this.calculateTotal(indentIndex, consIndex, section);
        }
      }
      // this.payment[this.column][section] = Number(val);
    },
    calculateTotal(indentIndex, consIndex, section) {
      let sum = 0;
      const sectionobj = this.$store.payments.selected[indentIndex].charges[consIndex];
      for (const i in this.aggrigate) {
        sum += Number(sectionobj[this.aggrigate[i]][section]);
      }
      sum -= Number(sectionobj.transit_charge[section]);
      sum -= Number(sectionobj.arrival_charge[section]);
      sum -= Number(sectionobj.shortage_charge[section]);
      sum -= Number(sectionobj.damage_charge[section]);
      sum -= Number(sectionobj.leakage_charge[section]);
      sum -= (sectionobj.carton_damage_charge ?
        Number(sectionobj.carton_damage_charge[section]) : 0);
      sum -= (sectionobj.wallet_penalty_charge ?
        Number(sectionobj.wallet_penalty_charge[section]) : 0);
      sum = (sum > 0) ? sum : 0;
      this.$store.payments.selected[indentIndex].charges[consIndex].total_amount[section] = Number(sum);
    },
    validateReadOnlyOnOldPayment(readonly) {
      if(this.$hasFeature('edit_delay_damage_by_transporter')){
        return false;
      }
      if (readonly) {
        return true;
      }
      return _.isEmpty(this.payment[this.column]) ? true : false;
    },
  },
  computed: {
    checkDataType() {
      const result = {};
      // if (this.payment.transporter[this.column].days || this.payment.transporter[this.column].days  === 0) {
      //   result = { label: 'Days', value: this.payment.transporter[this.column].days };
      // } else if (this.payment.transporter[this.column].qty || this.payment.transporter[this.column].qty ===0) {
      //   result = { label: 'Qty', value: this.payment.transporter[this.column].qty };
      // } else {
      //   result = { label: '', value: 0 };
      // }
      return result;
    },
    value: {
      get() {
        if(!this.$hasFeature('edit_invoice_post_invoice'))
        {
         return (this.invoiceStatus >= 3) ?
            this.amount('client', this.column) :
            this.amount('transporter', this.column);
        } else {
          return this.amount('transporter', this.column);
        }
      },
      set(val) {
        const getValue = val || 0;
        this.setObjDetail('transporter', this.column, getValue);
      },
    },
    options() {
      const options = [];
      const {payment_settings} = this.currentClientConfig;
      let checkColumns = {};
      if(payment_settings){
        checkColumns = payment_settings.column_hide_view;
      }

      if (this.daysCheck.includes(this.column)) {
        const splitColumn = this.column.split('_', 1);
        const delayRate = this.payment.days_damage[`${splitColumn}_delay`];
        if (delayRate) {
          options.push({
            value: delayRate,
            label: 'Days',
            fontweight: 'primary-text bold',
          });
        }
      }
      if (this.quantityCheck.includes(this.column)) {
        const splitColumn = this.column.split('_');
        const lastNameRemovedColumn = splitColumn.slice(0, splitColumn.length - 1).join('_');
        const qtyRate = this.payment.days_damage[lastNameRemovedColumn] || 0;
        if (qtyRate) {
          options.push({
            value: qtyRate,
            label: 'Quantity',
            fontweight: 'primary-text bold',
          });
        }
      }

      if (this.invoiceStatus >= 3) {
        options.push({
          value: this.amount('client'),
          label: 'Client',
          fontweight: 'primary-text bold',
        });
      }

      if (this.amount('transporter')) {
        options.push({
          value: this.amount('transporter'),
          label: 'Transporter',
          fontweight: 'primary-text bold',
        });
      }

      if (checkColumns && !checkColumns[this.column] && this.amount('system')) {
        options.push({
          value: this.amount('system'),
          label: 'System',
          fontweight: 'sec-text italics',
        });
      }

      return options;
    },
  },
};
</script>
<style lang="scss" scoped>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

input {
  border-color: transparent;
  background-color: transparent;
  outline: none;
  color: #404040;
}
.grey_out {
      background-color:rgba(238,242,244,0.6) !important;
    color: #234357 !important;
    //opacity: .6;
}
.red-border {
  background-color: #dbdbdb;
  font-family:$fontSemibold;
}
.top {
  padding-top: 0px;
}
.order-content {
  .el-popover__reference {
    cursor: pointer;
    padding: 2px 0;
  }
  .table-row {
    //padding: 0 15px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
.payment-popover {
  h3 {
    padding-left: 15px;
    text-transform: uppercase;
  }
  &.popover-primary {
    padding: 20px 20px 20px 10px;
  }
}
.primary-text {
  color: #008aff !important;
  font-family:$fontSemibold;
}
.sec-text {
  color: #969696;
  font-weight: 400;
}
.green-text {
  color: #04a537 !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}
.green-color {
  color: #04a537 !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}
.error-text {
  color: #e74c3c !important;
  font-family:$fontSemibold;
  margin-top: 0px;
}

.focus-contain {
  display: none;
  .primary-text {
    text-align: right;
    font-style: italic;
    color: #a3a3a3 !important;
  }
  .sec-text {
    text-align: right;
    font-style: italic;
    color: #234357;
  }
  &-close{
      text-align: right;
      padding: 10px 10px 5px 5px;
      cursor: pointer;
    }
  &-div {
    background-color: #fff;
    position: absolute;
    box-shadow: 0 0 30px 2px rgba(209, 208, 208, 0.5);
    margin-left: -10px;
    // padding-right: 10px;
    margin-top: 5px;
    display: block;
    //width: 132px;
    min-width: 80px;
    border-top: 1px solid #efefef;

    &-list {
      // padding: 7px 0;
      // padding: 10px 15px;
      padding-top: 6px;
        padding: 9px 5px;
      font-size: 1.2rem;
    }
    &-list:last-child {
      padding-bottom: 10px;
    }
    &-text {
      color: #404040;
      font-size: 0.8rem;
      display: block;
      line-height: 20px;
      padding: 0;
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: right;
    }
  }
  .input {
    border-bottom: 1px solid #efefef;
    padding-bottom: 0;
    padding-right: 0;
  }
}

.comment-pop{
    display: inline-block;
  }
  .text-areablock{
    padding: 0 10px 20px;
    textarea{
    border: 1px solid #D7D7D7;
    margin: 10px 5px;
    padding: 10px 5px;
  }
  .focus-contain-btn{
    text-align: right;
        padding-right: 5px;
  }
  }
.active {
  //width: 122px;
  display: block;
  height: 40px;
  position: absolute;
  vertical-align: middle;
  margin-top: 5px;
  //-webkit-box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  //box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  input {
    background: #fff;
    height: 40px;
    margin-top: -10px;
    //width: 133px;
    padding-left: 10px;
    margin-left: -11px;
    // padding-right: 5px;
    min-width: 110px;
  }
}
.read-text {
  color: #234357;
  font-family:$fontSemibold;
}
.activeborder {
  border: 1px solid #007fea !important;
  height: 40px !important;
}
.comment-inputfield{
  display: inline-block;
}
</style>
